import { isEmpty } from "lodash";
import { useContext, useEffect } from "react";
import {
  Modal,
  ModalBody,
  Badge,
  DropdownItem,
  UncontrolledDropdown,
  DropdownToggle,
  DropdownMenu,
  Alert,
} from "reactstrap";

import SiteTitle from "../../../helpers/SiteTitle/SiteTitle";
import Icon from "../../../components/Icon/Icon";
import PaginationComponent from "./../../../components/Pagination/Pagination";
import TableFilter from "../../../components/TableFilter/TableFilter";
import PageHeader from "../../../components/PageHeader/PageHeader";
import SearchTable from "../../../components/SearchTable/SearchTable";
import InfoItem from "./../../../helpers/InfoItem/InfoItem";
import UserAvatar from "./../../../components/UserAvatar/UserAvatar";
import UserInfoItem from "./../../../components/UserInfoItem/UserInfoItem";
import Currency, { ConvertCurrency } from "../../../helpers/Currency/Currency";
import { Block } from "./../../../components/Block/Block";
import {
  DataTable,
  DataTableBody,
  DataTableHead,
  DataTableItem,
  DataTableRow,
} from "./../../../components/DataTable/DataTable";
import { Col, Row } from "./../../../components/Grid/Grid";
import { shopOrderUserContext } from "../../../context/UserContext/ShopOrderUserContext/ShopOrderUserContext";
import { convertDate, numberSeparate } from "../../../utils";
import {
  categoryItems,
  convertPaymentTypeToColor,
  convertPaymentTypeToText,
} from "../../../utils/enum";

const ShopOrdersUser = () => {
  const {
    shopOrders,
    shopOrder,
    setShopOrder,
    filter,
    setFilter,
    sort,
    setSort,
    start,
    setStart,
    end,
    setEnd,
    pageCount,
    itemsCount,
    setItemsCount,
    pageNumber,
    setPageNumber,
    handleGetShopOrders,
  } = useContext(shopOrderUserContext);

  useEffect(() => {
    handleGetShopOrders();
  }, [start, end, pageNumber, itemsCount, sort]);

  return (
    <>
      <SiteTitle title="سفارشات فروشگاه" />

      <PageHeader title="سفارشات فروشگاه" />

      <TableFilter
        setItemsCount={setItemsCount}
        itemsCount={itemsCount}
        setSort={setSort}
        sort={sort}
        setStart={setStart}
        start={start}
        setEnd={setEnd}
        end={end}
      />

      <Block>
        <DataTable className="card-stretch">
          <SearchTable
            filterPlaceholder="کد پیگیری و ..."
            filter={filter}
            setFilter={setFilter}
            onSearch={handleGetShopOrders}
          />
          <DataTableBody>
            <DataTableHead>
              <DataTableRow>
                <span className="sub-text">#</span>
              </DataTableRow>
              <DataTableRow>
                <span className="sub-text">کاربر</span>
              </DataTableRow>
              <DataTableRow size="md">
                <span className="sub-text">فروشگاه</span>
              </DataTableRow>
              <DataTableRow size="sm">
                <span className="sub-text">جمع کل</span>
              </DataTableRow>
              <DataTableRow size="sm">
                <span className="sub-text">مبلغ کسر از کیف پول</span>
              </DataTableRow>
              <DataTableRow size="lg">
                <span className="sub-text">کد پیگیری</span>
              </DataTableRow>
              <DataTableRow size="xl">
                <span className="sub-text">تاریخ ایجاد</span>
              </DataTableRow>
              <DataTableRow />
            </DataTableHead>
            {/*Head*/}
            {shopOrders.length > 0
              ? shopOrders.map((item, index) => {
                  return (
                    <DataTableItem key={item._id}>
                      <DataTableRow>
                        <span>{index + 1}</span>
                      </DataTableRow>
                      <DataTableRow>
                        <div className="user-card">
                          <UserAvatar
                            {...(item?.customer?.user?.avatar
                              ? { image: item?.customer?.user?.avatar }
                              : {
                                  icon: "user-alt",
                                })}
                          />
                          <UserInfoItem
                            title={`${item?.customer?.user?.firstName} ${item?.customer?.user?.lastName}`}
                            subTitle={item?.customer?.user?.phoneNumber}
                          />
                        </div>
                      </DataTableRow>
                      <DataTableRow size="md">
                        <div className="user-card">
                          <UserAvatar
                            {...(item?.shop?.info?.avatar
                              ? { image: item?.shop?.info?.avatar }
                              : {
                                  icon: "user-alt",
                                })}
                          />
                          <UserInfoItem
                            title={item?.shop?.info?.title}
                            subTitle={item?.shop?.info?.address}
                          />
                        </div>
                      </DataTableRow>
                      <DataTableRow size="sm">
                        <ConvertCurrency price={item.totalAmount} />{" "}
                        <Currency />
                      </DataTableRow>
                      <DataTableRow size="sm">
                        <ConvertCurrency price={item.price} /> <Currency />
                      </DataTableRow>
                      <DataTableRow size="lg">
                        <span>{item.trackingCode}</span>
                      </DataTableRow>
                      <DataTableRow size="xl">
                        <span>
                          {convertDate(item.createdAt, "YYYY/MM/DD - HH:mm")}
                        </span>
                      </DataTableRow>

                      <DataTableRow className="nk-tb-col-tools">
                        <ul className="nk-tb-actions gx-1">
                          <li>
                            <UncontrolledDropdown>
                              <DropdownToggle
                                tag="a"
                                className="dropdown-toggle btn btn-icon btn-trigger"
                              >
                                <Icon name="more-h" />
                              </DropdownToggle>
                              <DropdownMenu
                                left
                                className="dropdown_max_height"
                              >
                                <ul className="link-list-opt no-bdr text-right">
                                  <li
                                    onClick={() => {
                                      setShopOrder(item);
                                    }}
                                  >
                                    <DropdownItem tag="a" type="button">
                                      <Icon name="eye" />
                                      <span>جزئیات</span>
                                    </DropdownItem>
                                  </li>
                                </ul>
                              </DropdownMenu>
                            </UncontrolledDropdown>
                          </li>
                        </ul>
                      </DataTableRow>
                    </DataTableItem>
                  );
                })
              : null}
          </DataTableBody>
          <div className="card-inner">
            {shopOrders.length > 0 ? (
              <PaginationComponent
                pageCount={pageCount}
                currentPage={pageNumber}
                setPageNumber={setPageNumber}
              />
            ) : (
              <div className="text-center">
                <span className="text-silent">داده ای برای نمایش یافت نشد</span>
              </div>
            )}
          </div>
        </DataTable>
      </Block>

      <Modal
        isOpen={!isEmpty(shopOrder) && !shopOrder.isStatus}
        toggle={() => setShopOrder({})}
        className="modal-dialog-centered"
        size="md"
      >
        <ModalBody>
          <span
            type="button"
            onClick={() => setShopOrder({})}
            className="close"
          >
            <Icon name="cross-sm" />
          </span>
          <div className="p-2">
            <h5 className="title">جزئیات سفارش {shopOrder.fullName}</h5>
            <br />
            <span className="text-primary border-bottom fw-bold">
              اطلاعات فروشگاه
            </span>
            <Row>
              <Col sm="6">
                <InfoItem title="نام">{shopOrder.shop?.info?.title}</InfoItem>
              </Col>
              <Col sm="6">
                <InfoItem title="آدرس">
                  {shopOrder.shop?.info?.address}
                </InfoItem>
              </Col>
            </Row>
            <br />
            <span className="text-primary border-bottom fw-bold">
              اطلاعات درخواست دهنده
            </span>
            <Row>
              <Col sm="6">
                <InfoItem title="نام">
                  {shopOrder.customer?.user?.firstName}
                </InfoItem>
              </Col>
              <Col sm="6">
                <InfoItem title="نام خانوادگی">
                  {shopOrder.customer?.user?.lastName}
                </InfoItem>
              </Col>
              <Col sm="6">
                <InfoItem title="شماره موبایل">
                  {shopOrder.customer?.user?.phoneNumber}
                </InfoItem>
              </Col>
              <Col sm="6">
                <InfoItem title="کدملی">
                  {shopOrder.customer?.user?.nationalNumber}
                </InfoItem>
              </Col>
              <Col sm="6">
                <InfoItem title="کد">{shopOrder.customer?.user?.code}</InfoItem>
              </Col>
              <Col sm="6">
                <InfoItem title="تاریخ تولد">
                  {convertDate(shopOrder.customer?.user?.birthDate)}
                </InfoItem>
              </Col>
              <Col sm="6">
                <InfoItem title="سمت">
                  {shopOrder.customer?.user?.post}
                </InfoItem>
              </Col>
              <Col sm="6">
                <InfoItem title="تعداد افراد تحت پوشش">
                  {shopOrder.customer?.user?.numberOfCovered}
                </InfoItem>
              </Col>
            </Row>
            <br />
            <span className="text-primary border-bottom fw-bold">
              اطلاعات سفارش
            </span>
            <Row>
              <Col sm="6">
                <InfoItem title="کد پیگیری">{shopOrder.trackingCode}</InfoItem>
              </Col>
              <Col sm="6">
                <InfoItem title="تاریخ ثبت سفارش">
                  {convertDate(shopOrder.createdAt, "YYYY/MM/DD - HH:mm")}
                </InfoItem>
              </Col>
              <Col sm="6">
                <InfoItem title="مبلغ کل">
                  <ConvertCurrency price={shopOrder.totalAmount} /> <Currency />
                </InfoItem>
              </Col>
              <Col sm="6">
                <InfoItem title="مبلغ کسر از کیف پول">
                  <ConvertCurrency price={shopOrder.price} /> <Currency />
                </InfoItem>
              </Col>
              <Col sm="6">
                <InfoItem title="ارزش افزوده">
                  {shopOrder.isAddedValue ? "دارد" : "ندارد"}
                </InfoItem>
              </Col>
              <Col sm="6">
                <InfoItem title="نوع پرداخت">
                  <Badge
                    color={convertPaymentTypeToColor(shopOrder.paymentType)}
                    className="badge-dim"
                  >
                    {convertPaymentTypeToText(shopOrder.paymentType)}
                  </Badge>
                </InfoItem>
              </Col>
            </Row>
            <br />
            <Alert color="info" className="text-justify">
              <InfoItem title="توضیحات">{shopOrder.description}</InfoItem>
            </Alert>
          </div>
        </ModalBody>
      </Modal>
    </>
  );
};

export default ShopOrdersUser;
